"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ty;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _compact = _interopRequireDefault(require("lodash/compact"));

var _flattenDeep = _interopRequireDefault(require("lodash/flattenDeep"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _union = _interopRequireDefault(require("lodash/union"));

var _tachyons = _interopRequireDefault(require("./tachyons"));

/* eslint-disable quotes */
function lexer(stringWithSpace) {
  return (0, _compact["default"])(stringWithSpace ? stringWithSpace.split(/\s/) : '');
}

function getTachyonsCSS(shorthand) {
  return _tachyons["default"][shorthand];
}

function mapTachyonsFragmentToCSSInJS(fragment) {
  return lexer(fragment).map(getTachyonsCSS);
}

function ty(tachyonsClassNameStrings) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  // eslint-disable-next-line func-names
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var cssFromExpressions = [];
    keys.forEach(function (key) {
      var value = typeof key === 'function' ? key.bind()(args[args.length - 1]) : key;
      cssFromExpressions.push(mapTachyonsFragmentToCSSInJS(value));
    });
    cssFromExpressions = (0, _flattenDeep["default"])(cssFromExpressions);

    if (typeof tachyonsClassNameStrings === 'function') {
      var ComponentClass = tachyonsClassNameStrings;

      var _ComponentClass = new ComponentClass(),
          componentSelector = _ComponentClass.name,
          componentStyles = _ComponentClass.styles;

      var tachyonsClassNameStringsParam = args[0];
      var inline = '';

      if (tachyonsClassNameStringsParam[0]) {
        var fragments = mapTachyonsFragmentToCSSInJS(tachyonsClassNameStringsParam[0]);
        fragments.map(function (item) {
          return (// eslint-disable-next-line implicit-arrow-linebreak
            Object.keys(item).forEach(function (key) {
              var isMediaQuery = key.charAt(0) === '@';

              if (isMediaQuery) {
                var mediaQueryProperty = item[key];
                inline += "".concat(key, " {");
                Object.keys(mediaQueryProperty).forEach(function (mediaQueryPropertyKey) {
                  var mediaQueryPropertyValue = mediaQueryProperty[mediaQueryPropertyKey];
                  return inline += "".concat(mediaQueryPropertyKey, ": ").concat(mediaQueryPropertyValue, ";");
                });
                return inline += "}";
              }

              return inline += "".concat(key, ": ").concat(item[key], ";");
            })
          );
        });
      }

      var regex = new RegExp("(.".concat((0, _autobahnUtilities.slugify)(componentSelector, {
        convertCamelCase: true
      }), ")+([{.#~ ]{1})"), 'gm');
      return "".concat(componentStyles.replace(regex, '$2'), " { ").concat(inline, " }");
    }

    var mapPropsToCSSInJS = function mapPropsToCSSInJS(props) {
      return (// eslint-disable-next-line implicit-arrow-linebreak
        (0, _union["default"])((0, _flattenDeep["default"])(tachyonsClassNameStrings.map(function (fragment, index) {
          /** get tachyons css from template literal */
          var cssFromString = mapTachyonsFragmentToCSSInJS(fragment);
          /** get tachyons css string from what's inside ${xxx} */

          var cssFromVariableString;

          if (typeof args[index] === 'string') {
            cssFromVariableString = mapTachyonsFragmentToCSSInJS(args[index]);
          } else if (typeof args[index] === 'function') {
            var functionResult = args[index](props);

            if ((0, _isArray["default"])(functionResult)) {
              // styled-is
              cssFromVariableString = (0, _flattenDeep["default"])(functionResult.map(mapTachyonsFragmentToCSSInJS));
            } else if (typeof functionResult === 'string') {
              // ${({ blue }) => blue && 'bgBlue'}
              cssFromVariableString = mapTachyonsFragmentToCSSInJS(functionResult);
            }
          }

          var cssFromVariable = cssFromVariableString || [];
          return [].concat((0, _toConsumableArray2["default"])(cssFromString), (0, _toConsumableArray2["default"])(cssFromVariable), (0, _toConsumableArray2["default"])(cssFromExpressions));
        })))
      );
    };

    return mapPropsToCSSInJS;
  };
}